import { render } from "./ACard.vue?vue&type=template&id=ca1f2c4e&scoped=true"
import script from "./ACard.vue?vue&type=script&lang=js"
export * from "./ACard.vue?vue&type=script&lang=js"

import "./ACard.vue?vue&type=style&index=0&id=ca1f2c4e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca1f2c4e"]])

export default __exports__